import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { formEditable, TFormEditableCodec } from "../../../shared/src/codecs/types/formEditable";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { TAnyUuidCodec, uuid } from "../../../shared/src/codecs/types/uuid";

const BuyerUpdatesClientDetailsFields = required({
    enquiry_id: uuid(),
    homes_first_legal_name: string(),
    homes_middle_legal_name: string(),
    homes_last_legal_name: string(),
    purchasers_address: string(),
    purchasers_company_name: string(),
});

type TBuyerUpdatesClientDetailsFieldsCodec = TRequiredCodec<{
    enquiry_id: TAnyUuidCodec;
    homes_first_legal_name: TAnyStringCodec;
    homes_middle_legal_name: TAnyStringCodec;
    homes_last_legal_name: TAnyStringCodec;
    purchasers_address: TAnyStringCodec;
    purchasers_company_name: TAnyStringCodec;
}>;

export const BuyerUpdatesClientDetailsFormEditable: TFormEditableCodec<TBuyerUpdatesClientDetailsFieldsCodec> = formEditable(BuyerUpdatesClientDetailsFields);

export type TBuyerUpdatesClientDetailsFormEditableCodec = typeof BuyerUpdatesClientDetailsFormEditable;

export type TBuyerUpdatesClientDetailsFormEditable = TTypeOfCodec<TBuyerUpdatesClientDetailsFormEditableCodec>;

export type TBuyerUpdatesClientDetailsFormEditableNewDefault = TTypeOfNewDefault<TBuyerUpdatesClientDetailsFormEditableCodec>;
